import * as React from "react";
import {Popup} from "semantic-ui-react";

interface ILeftMenuIcon {
    handleSlideFromLeft: () => void;
    isVisible: boolean;
    content: string;
}

const LeftMenuIcon: React.SFC<ILeftMenuIcon> = ({handleSlideFromLeft, isVisible, content}) => (
    <Popup
        className='left-menu-custom-popup'
        content={content}
        trigger={<div className="left-menu-icon-container" onClick={() => handleSlideFromLeft()}>
            <div className={`left-menu-icon ${isVisible ? 'icon-fist-bar-transform' : ''} `} />
            <div className={`left-menu-icon ${isVisible ? 'icon-second-bar-transform' : ''} `} />
            <div className={`left-menu-icon ${isVisible ? 'icon-third-bar-transform' : ''} `} />
        </div>}
        position='bottom right'
        inverted={true}
    />

);

export default LeftMenuIcon;



// WEBPACK FOOTER //
// ./src/components/NavLink/LeftMenuIcon.tsx